import React from 'react';
import {observer} from 'mobx-react';
import Icon from '../common/Icon';
import Cell from './GridCell';

const ViewSpecsheetCell = ({row, showPDF, onExpand, dormant = false}) => {
	const hasMultisheets = row.hasMultipleSpecsheets;
	const hasSpecsheet = !!row.specsheet;
	if (row.isAll) {
		return <Cell modifiers={{fixed: true}}/>;
	} else if (hasMultisheets) {
		return (<Cell modifiers={{fixed: true, hasDownload: true}} onClick={() => onExpand(row)}>
			<Icon name={row.viewSpecsheetExpanded ? 'chevron-large-up': 'chevron-large-down'} width="17" height="10"/>
		</Cell>);
	} else if (hasSpecsheet && !dormant) {
		return (<Cell modifiers={{fixed: true, preview: true}} onClick={() => showPDF(row.specsheet)}>
			{<Icon name={'preview'} width="15" height="15"/>}
		</Cell>);
	} else if (dormant) {
		return <Cell modifiers={{fixed: true, dormant: true}}/>;
	}
	return <Cell modifiers={{fixed: true}}/>;
};
export default observer(ViewSpecsheetCell);

